import type { Listeners } from '../helpers';
import { controllerHelpers } from '../helpers';
import type {
  RouterNonUiManager,
  PaymentButtonManager,
  AddOnsManager,
  PayflowProgressBarManager,
  PrepaySelectManager,
} from '../managers';
import { orderSummaryEventBus } from '../managers';

export class OrderSummaryController {
  public listeners: Listeners;

  constructor(
    private paymentButtonManager: PaymentButtonManager,
    private routerManager: RouterNonUiManager,
    private addOnsManager?: AddOnsManager,
    private payflowProgressBarManager?: PayflowProgressBarManager,
    private prepaySelectManager?: PrepaySelectManager
  ) {
    const eventConnections = [
      orderSummaryEventBus.bindTo('ratingCallPending', this.onIsLoading),
      orderSummaryEventBus.bindTo('editPlanClicked', this.onEditPlanClicked),
      orderSummaryEventBus.bindTo('totalPriceUpdated', this.onTotalPriceUpdated),
      orderSummaryEventBus.bindTo('addOnRemoved', this.onAddOnRemoved),
      orderSummaryEventBus.bindTo('editAddOnClicked', this.onEditAddOn),
      orderSummaryEventBus.bindTo('smsBundleTierEditClicked', this.onSmsBundleTierEditClicked),
    ];

    this.listeners = controllerHelpers.createListeners(eventConnections);
  }

  private onIsLoading = (isChanging: boolean) => {
    this.paymentButtonManager.getApiWhenReady().then((api) => {
      if (isChanging) {
        api.disable();
      } else {
        api.enable();
      }
    });

    this.prepaySelectManager?.getApiWhenReady().then((api) => {
      if (isChanging) {
        api.disable();
      } else {
        api.enable();
      }
    });
  };

  private onEditPlanClicked = () => {
    // This is temporary. We don't want this to link to the new flow permanently until it's properly tested and released.
    if (this.payflowProgressBarManager) {
      this.payflowProgressBarManager.getApiWhenReady().then((api) => api.goToPlans());
    } else {
      this.routerManager.getApiWhenReady().then((api) => api.goToFosPricingV2());
    }
  };

  private onEditAddOn = () => {
    this.payflowProgressBarManager?.getApiWhenReady().then((api) => api.goToAddOns());
  };

  private onSmsBundleTierEditClicked = () => {
    this.addOnsManager?.getApiWhenReady().then((api) => api.openSmsBundleTierModal());
  };

  private onTotalPriceUpdated = (totalPrice: string) => {
    this.paymentButtonManager.getApiWhenReady().then((api) => {
      api.setPriceLabel(totalPrice);
    });
  };

  private onAddOnRemoved = async (addOnId: string) => {
    this.addOnsManager?.getApiWhenReady().then((api) => api.removeAddOn(addOnId));
  };
}
